import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CSSModules from 'react-css-modules';
import { showPokeregi, invalidatePokeregi } from 'admin/actions/devices';
import { openAlertModal } from 'admin/actions/alert-modal';
import { canCreateDevice, canInvalidatePokeregi } from 'admin/routes';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import { formatUUID, formatNum, formatPokeregiName, formatPokeregiTopupMode, formatDeviceModel, formatDeviceFirmwareVersion } from 'admin/utils';
import styles from './styles.scss';

class Pokeregi extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const id = this.props.match.params.id;
    this.props.showPokeregi(id);
  }

  componentWillUpdate(newProps, newState) {
    if (newProps.api_error !== this.props.api_error) {
      const getMessage = (e) => {
        const { type, message } = e;
        switch (type) {
          case 'account_not_accessible':
            return "アカウントにアクセスできません"
          default:
            if (message === 'Not Found') {
              return `見つかりませんでした`;
            }
            return "処理に失敗しました";
        }
      };
      this.props.openAlertModal({
        body: (
          <p>{getMessage(newProps.api_error)}</p>
        ),
        confirmText: "もどる",
        onConfirm: () => {
          this.props.history.goBack();
        },
        useCancel: false,
      });
    }
  }

  edit() {
    this.props.history.push(`/settings/devices/pokeregi/${this.props.match.params.id}/edit`);
  }

  invalidate() {
    this.props.openAlertModal({
      body: (
        <p>
          一度無効化すると元に戻すことはできません。<br />
          無効化してよろしいですか？
        </p>
      ),
      confirmText: "無効化する",
      confirmColor: "danger",
      onConfirm: () => {
        this.props.invalidatePokeregi(this.props.match.params.id)
        this.props.openAlertModal({
          body: (
            <p>
              ポケレジを無効化しました。<br />
              今後、決済することはできなくなりました。
            </p>
          ),
          useCancel: false,
        });
      },
    });
  }

  back() {
    this.props.history.goBack();
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'ポケレジ詳細', href: '', active: true },
    ];
    return (
      <div>
        <div>
          <Breadcrumb items={crumb} />
          <div>
            <row styleName="row">
              <div styleName="cat-label">ポケレジ設定</div>
              <div styleName="cat-val">
                <row styleName="row">
                  <div styleName="label">製造番号</div>
                  <div styleName="val">{this.props.pokeregi.serial_number}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">機種名</div>
                  <div styleName="val">{formatDeviceModel(this.props.pokeregi.pcb_ver)}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">ファームウェア</div>
                  <div styleName="val">{formatDeviceFirmwareVersion(this.props.pokeregi.fw_ver)}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">チャージの可/不可</div>
                  <div styleName="val">{formatPokeregiTopupMode(this.props.pokeregi.topup_mode)}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">最大入力可能金額</div>
                  <div styleName="val">¥{formatNum(this.props.pokeregi.transfer_limit)}</div>
                </row>
              </div>
            </row>
            <row styleName="row">
              <div styleName="cat-label">設置先設定</div>
              <div styleName="cat-val">
                <row styleName="row">
                  <div styleName="label">設置店舗名</div>
                  <div styleName="val">{this.props.pokeregi.shop_name}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">マネー名</div>
                  <div styleName="val">{this.props.pokeregi.money_name}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">アカウント名</div>
                  <div styleName="val">{this.props.pokeregi.account_name}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">端末名</div>
                  <div styleName="val">{formatPokeregiName(this.props.pokeregi.name, this.props.pokeregi.serial_number)}</div>
                </row>
                <row styleName="row">
                  <div styleName="label">ID</div>
                  <div styleName="val">
                    <li>端末ID: {formatUUID(this.props.pokeregi.terminal_id)}</li>
                    <li>ハードウェアID: {formatUUID(this.props.pokeregi.hardware_id)}</li>
                    <li>アカウントID: {formatUUID(this.props.pokeregi.account_id)}</li>
                  </div>
                </row>
                <row styleName="row">
                  <div styleName="label">決済状態</div>
                  <div styleName="val">
                  {
                    this.props.pokeregi.is_invalidated ?
                    <div>無効 (決済不可能)</div> :
                    <div>
                      有効 (決済可能)
                      {
                        (canInvalidatePokeregi.includes(this.props.user.role)) ?
                        <Button onClick={this.invalidate.bind(this)} color="danger" styleName="button-right">無効化</Button> :
                        null
                      }
                    </div>
                  }
                  </div>
                </row>
              </div>
            </row>
          </div>
          <div styleName="button-group">
            {
              (canCreateDevice.includes(this.props.user.role)) ?
              <Button onClick={this.edit.bind(this)}>ポケレジ設定変更・設置先変更</Button> :
              null
            }
            <Button onClick={this.back.bind(this)} color="gray">戻る</Button>
          </div>
        </div>
      </div>
    );
  }
}

Pokeregi.defaultProps = {
  user: {},
  pokeregi: {},
  api_error: null,
};

const mapStateToProps = state => ({
  user: state.user,
  pokeregi: state.device.pokeregi,
  api_error: state.apiError.error,
});

Pokeregi.propTypes = {
  user: PropTypes.object,
  pokeregi: PropTypes.shape({
    terminal_id: PropTypes.string,
    hardware_id: PropTypes.string,
    is_invalidated: PropTypes.boolean,
    account_id: PropTypes.string,
    name: PropTypes.string,
    shop_name: PropTypes.string,
    shop_id: PropTypes.string,
    organization_name: PropTypes.string,
    organization_code: PropTypes.string,
    account_name: PropTypes.string,
    money_name: PropTypes.string,
    serial_number: PropTypes.number,
    pcb_ver: PropTypes.string,
    fw_ver: PropTypes.string,
    topup_mode: PropTypes.string,
    transfer_limit: PropTypes.number,
  }),
  api_error: PropTypes.object,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  showPokeregi, invalidatePokeregi, openAlertModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Pokeregi, styles));
